import createNestedObject from './createNestedObject';

/**
 *
 * @param {Object} objectOfCreation - An object with each property reprensting something to create.
 * @example
 * objectOfCreation: {
 *		randomNameYouChoose: {
 *			objectPath: 'aaa.bbb', // path to create on window object window.aaa.bbb
 *			value: 'defaultValue' // default value
 *		}
 *	}
 */
const create = (objectOfCreation, win) => {
	Object.values(objectOfCreation).forEach(({ objectPath, value }) => {
		if (objectPath && value) {
			const valueCopy = JSON.parse(JSON.stringify(value));
			createNestedObject(
				win,
				objectPath,
				valueCopy === 'emptyfunc' ? () => {} : valueCopy
			);
		}
	});
};

export default create;
